__turbopack_context__.v({
  "list": "custom-select-module__i0aKCG__list",
  "option": "custom-select-module__i0aKCG__option",
  "panel": "custom-select-module__i0aKCG__panel",
  "selected": "custom-select-module__i0aKCG__selected",
  "wrapper": "custom-select-module__i0aKCG__wrapper",
});
